import { gql } from "urql";
export const GetConditionCountQuery = gql `
    query GetConditionCount($search: String) {
        conditions {
            conditionCount(search: $search)
        }
    }
`;
export const GetConditionsQuery = gql `
    query GetConditions($search: String, $offset: Int) {
        conditions {
            conditions(search: $search, offset: $offset) {
                conditionId
                name
                isActive
            }
        }
    }
`;
export const GetConditionListQuery = gql `
    query GetConditionList {
        conditions {
            conditionsList {
                value
                label
            }
        }
    }
`;
